import Box from '@mui/material/Box';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import CrumbContent from './CrumbContent';
import { Link as RouterLink, useMatches } from 'react-router-dom';
import { useBreadcrumbParams } from '../../hooks/useBreadcrumbParams';
import { RouteMatch } from '../../types/breadcrumbTypes';
import breadcrumbStyles from './breadcrumbStyles';

const DynamicBreadcrumbs = () => {
  const matches = useMatches() as RouteMatch[];
  const { params, searchParams, getPermittedSearch } = useBreadcrumbParams();

  const crumbs = matches
    .filter((match) => match.handle?.crumb)
    .map((match) => ({
      id: match.id,
      path: match.pathname,
      config: match.handle!.crumb!,
    }));

  if (crumbs.length === 0) return null;

  return (
    <Box>
      <Breadcrumbs>
        {crumbs.map((item, index) => {
          const LinkPath = item.config.redirectTo ?? item.path;
          const searchString = getPermittedSearch(item.config.permitSearchParams);
          const isLast = index === crumbs.length - 1;

          if (isLast) {
            return (
              <Typography
                key={item.id}
                component="span"
                color={'text.primary'}
                sx={breadcrumbStyles.element}
              >
                <CrumbContent config={item.config} params={params} searchParams={searchParams} />
              </Typography>
            );
          }

          return (
            <Box
              key={item.id}
              component={RouterLink}
              to={{ pathname: LinkPath, search: searchString }}
              sx={breadcrumbStyles.box}
            >
              <CrumbContent config={item.config} params={params} searchParams={searchParams} />
            </Box>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};

export default DynamicBreadcrumbs;
